import React from 'react'
import IosAppImage from './ios-app.svg'
import GoogleAppImage from './google-play-store.svg'
import { CONFIG, FEATURES } from '../../config'
import * as styles from './styles.module.scss'
import { getSmartyVAT } from '@smarty-nx/data'

const Footer = () => (
  <footer role="contentinfo" className={styles.Footer}>
    <div className={styles.Links}>
      <ul>
        <li>
          <a href="https://help.smarty.co.uk/all-about-smarty/terms-conditions">
            Terms and conditions
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}privacy`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy policy <span>(PDF)</span>
          </a>
        </li>
        <li>
          <a href={`${CONFIG.MARKETING_URL}accessibility`}>Accessibility</a>
        </li>
        <li>
          <a
            href="https://cdn.smarty.co.uk/files/smarty-vulnerability-policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vulnerable situations policy <span>(PDF)</span>
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}cookies`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookies policy <span>(PDF)</span>
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}complaints`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Complaints
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}free-sim`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Free SIM
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}sim-only`}
            target="_blank"
            rel="noopener noreferrer"
          >
            SIM only
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}pay-as-you-go`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Pay as you go
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}data-sim`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Data SIM
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}no-credit-check-sim`}
            target="_blank"
            rel="noopener noreferrer"
          >
            No credit check
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}plans/unlimited`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Unlimited SIM
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}student-sim`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Student SIM
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}data-rollover`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Data Rollover
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}5g`}
            target="_blank"
            rel="noopener noreferrer"
          >
            5G
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a
            href="https://help.smarty.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            Support
          </a>
        </li>
        <li>
          <a href={`${CONFIG.MARKETING_URL}contact`}>Contact us</a>
        </li>
        <li>
          <a href={`${CONFIG.MARKETING_URL}app`}>App</a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}priceguide`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Price guide <span className="pdf-icon">(PDF)</span>
          </a>
        </li>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}roaming`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Roaming &amp; International
          </a>
        </li>
        <li>
          <a href={CONFIG.BLOG_URL} target="_blank" rel="noopener noreferrer">
            Blog
          </a>
        </li>
        <li>
          <a
            href="http://www.three.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            three.co.uk
          </a>
        </li>
        {FEATURES.SHORT_CODES && (
          <li>
            <a
              href={`${CONFIG.MARKETING_URL}shortcodes-checker`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Shortcode checker
            </a>
          </li>
        )}
      </ul>
      <ul>
        <li>
          <a
            href={`${CONFIG.MARKETING_URL}activate`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Activate SIM
          </a>
        </li>
        <li>
          <button
            id="cookieConsent"
            onClick={() => window.OneTrust.ToggleInfoDisplay()}
            className={styles.cookiePreferencesBtn}
          >
            Cookie preferences
          </button>
        </li>
        <li>
          <a
            href="https://apps.apple.com/app/apple-store/id1540812668?pt=421745&mt=8&ct=smarty_web_download"
            target="_blank"
            rel="noopener noreferrer"
            data-item-category="NV"
            data-item-name="ios-app-download-link"
          >
            <img
              src={IosAppImage}
              className={styles.IosApp}
              alt="Ios App"
              data-testid="ios-app"
              aria-label="iOS App"
            />
          </a>
        </li>
        <li>
          <a
            href="https://play.google.com/store/apps/details?id=com.hutchison3g.sundae&referrer=utm_source%3Dsmarty%26utm_medium%3Dweb%26utm_content%3Dappstore_logo"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Google Play store App"
            data-item-category="NV"
            data-item-name="android-app-download-link"
          >
            <img
              src={GoogleAppImage}
              className={styles.GoogleApp}
              alt="Google Play Store App"
              data-testid="google-play-store-app"
            />
          </a>
        </li>
      </ul>
    </div>
    <div className={styles.Social}>
      <span>Follow SMARTY</span>
      <a
        href="https://www.facebook.com/SMARTYMobileuk"
        rel="noopener noreferrer"
        target="_blank"
        className={styles.facebook}
      >
        Facebook
      </a>
      <a
        href="https://x.com/SMARTYMobileUK"
        rel="noopener noreferrer"
        target="_blank"
        className={styles.x}
      >
        X
      </a>
      <a
        href="https://www.youtube.com/@SMARTYMobileUK"
        rel="noopener noreferrer"
        target="_blank"
        className={styles.youtube}
      >
        YouTube
      </a>
      <a
        href="https://www.linkedin.com/company/smartymobile-uk/"
        rel="noopener noreferrer"
        target="_blank"
        className={styles.linkedin}
      >
        LinkedIn
      </a>
      <a
        href="https://www.instagram.com/smartymobileuk/"
        rel="noopener noreferrer"
        target="_blank"
        className={styles.instagram}
      >
        Instagram
      </a>
    </div>
    <div className={styles.Terms}>
      <p>© {new Date().getFullYear()} All rights reserved. SMARTY.</p>
      <p>
        <a href="https://www.smarty.co.uk">smarty.co.uk</a>
      </p>
      <p data-testid="footer-personal-use">
        SMARTY is a service that’s just for consumers and is only intended for
        personal use.
      </p>
      <p data-testid="footer-trading">
        SMARTY is a trading name of Hutchison 3G UK Limited
      </p>
      <div>
        <p data-testid="footer-address">
          Registered office: Hutchison 3G UK Limited, 450 Longwater Avenue,
          Green Park, Reading, Berkshire, RG2 6GF
        </p>
        <p data-testid="footer-comp-num">
          Registered in England & Wales Number 03885486
        </p>
        <p data-testid="footer-vat">
          VAT Registration Number {getSmartyVAT(FEATURES.VAT_UPDATE)}
        </p>
      </div>
      {CONFIG.SMARTY_ENV !== 'production' && (
        <p data-testid="footer-commit">Git: {CONFIG.COMMIT}</p>
      )}
    </div>
  </footer>
)

export default Footer
